import Api from "./../../../../services/api"

export default {
  name: "QuestionsAnswersPrivate",
  props: {
    display: {
      type: Boolean,
      default: true,
    },
    comment: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      questionsForm: {
        question: "",
      },
      questions: [],
    }
  },
  watch: {
    comment(value) {
      let answers = value.filter(item => item.parentId != "0")
      this.questions = value.filter(item => item.parentId == "0").map(item => {
        item.answers = []
        item.answerActive = false;
        return item
      })

      this.questions.forEach(q => {
        q.answers = answers.filter(a => a.parentId == q._id)
      })

      // Add answers to question
      // answers.forEach(function(element) {
      //   let question = value.find(item => item.parentId == "0")
      //   question.answers.push(element)
      // })
    }
  },
  filters: {
    filterDate(value) {
      if (value) {
        var monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ]

        var date = new Date(value),
          month = monthNamesShort[date.getMonth()],
          day = date.getDate(),
          year = date.getFullYear()

        if (month.length < 2) month = "0" + month
        if (day.length < 2) day = "0" + day

        return month + ". " + day + ", " + year
      }

      return ""
    },
  },
  methods: {
    show() {
      this.display = true
    },
    hide() {
      this.display = false
    },
    async askQuestion(question) {
      try {
        let isValid = await this.$validator.validateAll("questionsForm")
        if (!isValid) return

        this.$parent.$refs.progress.show()

        var response = await Api.createQuestionsAnswers(
          this.$route.params.id,
          this.questionsForm.answer,
          question._id
        )

        if (response.data.message) {
          alert(response.data.message)
          return
        }

        question.answers.push(response.data.results);
        question.answerActive = false;
        this.questionsForm.answer = "" // cleaning
      } catch (error) {
        console.error(error)
        alert(error.message)
      } finally {
        $("#modalGiveReviews").modal("close")
        this.$parent.$refs.progress.hide()
      }
    },
    openAnswer(question) {
      if(question.answerActive == true) this.questions.forEach(e => e.answerActive = false);
      else {
        this.questions.forEach(e => e.answerActive = false);
        question.answerActive = true;
      }
      this.questions = [].concat(this.questions);
    }
  },
  computed: {
    questionsList() {
      return this.questions;
    }
  } 
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Widget/QuestionsAnswersPrivate/QuestionsAnswersPrivate.component.js